import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CMM } from '../../Lib/Cmm.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { authStore } from 'store/authStore';
import uuid from 'react-uuid';
import { observer } from 'mobx-react-lite';
import Header from "components/Headers/Header.js";
import QuillEditor from "components/QuillEditor.js";
import { NavLink as NavLinkRRD, Link, useLocation, useNavigate } from "react-router-dom";
import { GoChevronRight, GoChevronLeft } from "react-icons/go";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";
import { fetchAxios, postAxios, postNoauth, postWithFile } from 'Lib/GetAxios';
import { etcStore } from 'store/etcStore';
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  Container,
  Row,
  Col,
  Input,
} from "reactstrap";

// import React, { Suspense, lazy } from 'react';
// const QuillEditor = lazy(() => import('components/QuillEditor'), { ssr: false });


let maxPageNo;
let u_uuid;

const Notification = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);

  const [regi, setRegi] = useState({
    n_idx: 0,
    title: '',
    content: '',
    html_yn: 'Y',
  })

  //데이터 가져오기
  useEffect(() => {
    getData();
  }, []);

  const handleEditorChange = (newContent) => {
    setRegi(prev => ({ ...prev, content: newContent }));
    // setContent(newContent);
  };

  //공지 추가/수정
  const sendRegi = useCallback(async () => {

    const res = await postAxios(`${CMM.SERVER_URL_API}/admin/noti_edit`, {
      n_idx: regi.n_idx,
      title: regi.title,
      content: regi.content,
      html_yn: regi.html_yn,
    }).then((res) => {
      if (res != 'ERROR') {

        alert('OK');
        navigate('/admin/notification');

      }
    })
      .catch((e) => {
        console.log('error::', e.message);
      })

  }, [data, regi]);

  //상세 데이터 가져오기
  const getData = useCallback(() => {

    if (etcStore.mainData.notificationEdit_uuid) {
      fetchAxios(`${CMM.SERVER_URL_API}/admin/noti_detail`,
        {
          idx: etcStore.mainData.notificationEdit_uuid,
        })
        .then((res) => {
          if (res != 'ERROR') {

            setData(res);

            setRegi(prev => ({ ...prev, title: res[0].title }));
            setRegi(prev => ({ ...prev, content: res[0].note }));
            setRegi(prev => ({ ...prev, n_idx: res[0].noti_idx }));


          }
        })
        .catch((e) => {
          console.log('error::', e.message)
        })
    }


  }, [etcStore.mainData.notificationEdit_uuid, data]);


  const toastMessage = () => {
    //토스트 메시지
    toast.success('성공적으로 변경되었습니다.', {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }


  return (
    <>
      <Header />
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />
      <Container className="mt--7 position-absolute start-0" fluid style={{ maxWidth: '1300px', }}>

        <Card
          className="pt-3 pb-5">
          <CardHeader className="bg-white">
            <div className="font-weight-bold "
              style={{ lineHeight: 1.2 }}>
              <h1 className="d-inline-block"
                style={{ color: 'black' }}>
                공지 사항 작성</h1>
            </div>
          </CardHeader>
          <>
            <CardBody className=" p-0 " style={{ minHeight: '700px' }}>
              <Col className="mb-xl-0 p-0">
                {/* <!-- 제목 입력--> */}
                <div className="flex justify-content-start flex-col">
                  <label for="" className=" d-inline-block text-lg text-dark font-weight-bold m-3">제목</label>
                  <input
                    type="text"
                    className="h-[45px] d-inline-block  w-full rounded-lg border text-sub-text-1 ring-1 ring-inset ring-line-3 placeholder:text-hint-text p-1"
                    placeholder={''}
                    maxLength='30'
                    onChange={(e) => {
                      setRegi(prev => ({ ...prev, title: e.target.value }));
                    }}
                    value={regi.title}
                  />
                </div>
                {/* <!-- 내용 입력 --> */}
                <div>
                  <QuillEditor
                    onChange={handleEditorChange}
                    value={regi.content}
                    //modules={quillModules}
                    className="w-full my-3 bg-white "
                  />
                </div>
              </Col>
            </CardBody>
          </>

          <button
            className="btn btn-sm text-white p-2 shadow-none border-0 d-inline w-25 m-auto text-sm"
            style={{ backgroundColor: '#0591D9' }}
            onClick={(e) => {
              e.preventDefault();
              sendRegi();
            }}
          >
            저장
          </button>

        </Card>
      </Container >
    </>
  );
};

export default Notification;
